import { EventApi } from 'api';
import { useAuthMutation } from 'queries/query';

function useCreate() {
  return useAuthMutation(EventApi.post);
}

export default useCreate;
